import NavbarUser from './NavbarUser'

const ThemeNavbar = () => {
    return <NavbarUser/>
}

export default ThemeNavbar
